export default {
	props:{
		formTitle:{type:String, default(){ return this.$t('registrationForm.formTitle');} },
		submitUrl:{type:String, default:''},
		value:{type:Object, default(){ return {};} },
		phoneCcOptions:{type:Array, default(){ return [];} },
		googleReCaptchaV3SiteKey:{type:String, default: ''},
	},
	data(){
		return {
			formData: {
				is_company:'0',
				first_name:'', last_name:'',  email:'', phone_cc:'', phone:'',
				company_name:'', company_address:'', company_reg_no:'', company_vat_no:'', company_rp_name:'',
				password:'', password2:'',
			},
			formErrors: {},
			successMsg: '',
		}
	},
	watch: {
		value:{
			immediate:true,
			deep:true,
			handler(val){
				for(const fld in this.formData){
					if(typeof(val[fld])!=='undefined' && val[fld]!==this.formData[fld]){
						this.$set(this.formData, fld, val[fld]);
					}
				}
			},
		},
		formData:{
			deep:true,
			handler(val){
				this.$emit('input', val);
			},
		},
	},
	computed:{
		actionName(){
			return 'doRegistration';
		},
		actionUrl(){
			const url = new URL(this.submitUrl?this.submitUrl:window.location.href);
			url.searchParams.set('action', this.actionName);
			return url.href;
		},
		phoneInputErrors(){
			return {phoneCc:this.formErrors.phone_cc, phone:this.formErrors.phone};
		},
		hasErrors(){
			return this.formErrors && Object.values(this.formErrors).length;
		},
	},
	methods: {
		onChangePassword(){
			if(this.formData.password!==this.formData.password2){
				this.$set(this.formErrors, 'password2', this.$t('errors.invalidField'));
			} else {
				this.$set(this.formErrors, 'password2', '');
			}
		},
		async onFormSubmit(event){
			this.$refs.registrationForm.classList.add('submitting');
			this.formErrors = {};
			this.successMsg = '';
			const formData = Object.assign({}, this.formData);

			if(this.googleReCaptchaV3SiteKey){
				formData.grc_token = await this.$refs.googleReCaptchaV3.generateRecaptchaToken(this.actionName);
			}

			doFetch(this.actionUrl, {}, {'formData':formData})
				.then((res) => {
					if (!res || !res.success){
						this.formErrors = res.errors ? res.errors : {'main':'Unknown error!'};
						return;
					}
					this.successMsg = res.success_msg;
					this.$emit('success', {success_msg:res.success_msg});
				})
				.catch((error)=>{
					//error
					alert('Unknown error!');
				})
				.finally(()=>{
					this.$refs.registrationForm.classList.remove('submitting');
				});
		},
	},
	template: `
<form ref="registrationForm" class="registration-form client-form" @submit.prevent="onFormSubmit">
	<div v-if="formTitle" class="form-top">{{formTitle}}</div>
  <div class="form-content">
    <qit-input-radiogroup
        name="client[is_company]"
        v-model="formData.is_company"
        :options="[{value:'0',label:'client.imPerson'},{value:'1',label:'client.imCompany'}]"
    ></qit-input-radiogroup>
		<qit-input-text
        name="client[first_name]" class="v1"
				:label="$t('client.nameFirst')" :floating-label="true" 
				v-model="formData.first_name" :error-msg="formErrors.first_name"
		></qit-input-text>
		<qit-input-text
        name="client[last_name]" class="v1"
				:label="$t('client.nameLast')" :floating-label="true" 
				v-model="formData.last_name" :error-msg="formErrors.last_name"
		></qit-input-text>
		<qit-input-text
        name="client[email]" class="v1" type="email"
				:label="$t('client.email')" :floating-label="true" 
				v-model="formData.email" :error-msg="formErrors.email"
		></qit-input-text>
		<qit-input-phone
        :floating-label="true"
        phone-cc-name="client[phone_cc]"
        :phone-cc.sync="formData.phone_cc"
        :phone-cc-options="phoneCcOptions"
        phone-name="client[phone]"
        :phone.sync="formData.phone"
        :errors="phoneInputErrors"
		></qit-input-phone>

    <div v-if="formData.is_company==='1'" class="company-details">
      <qit-input-text
          name="client[company_name]" class="v1"
					:label="$t('company.name')" :floating-label="true"
          v-model="formData.company_name" :error-msg="formErrors.company_name"
      ></qit-input-text>
      <qit-input-text
          name="client[company_address]" class="v1"
					:label="$t('company.address')" :floating-label="true"
          v-model="formData.company_address" :error-msg="formErrors.company_address"
      ></qit-input-text>
      <qit-input-text
          name="client[company_reg_no]"
          class="v1" :label="$t('company.reg_no')" :floating-label="true"
          v-model="formData.company_reg_no"
          :error-msg="formErrors.company_reg_no"
      ></qit-input-text>
      <qit-input-text
          name="client[company_vat_no]" class="v1"
					:label="$t('company.vat_no')" :floating-label="true"
          v-model="formData.company_vat_no" :error-msg="formErrors.company_vat_no"
      ></qit-input-text>
      <qit-input-text
          name="client[company_rp_name]" class="v1"
					:label="$t('company.rp_name')" :floating-label="true"
          v-model="formData.company_rp_name" :error-msg="formErrors.company_rp_name"
      ></qit-input-text>
    </div>

		<qit-input-text 
				class="v1" type="password"
				:label="$t('client.password')" :floating-label="true"
				v-model="formData.password" :error-msg="formErrors.password"
        @change="onChangePassword"
		></qit-input-text>
		<qit-input-text 
				class="v1" type="password"
				:label="$t('client.password2')" :floating-label="true"
				v-model="formData.password2" :error-msg="formErrors.password2"
				@change="onChangePassword"
		></qit-input-text>
	</div>
	<div class="form-bottom">
		<button class="btn text-transform-none button fill" name="btnSubmit" :value="actionName" v-t="'registrationForm.btnRegisterMe'"></button>
	</div>
	<div v-if="formErrors.main" class="form-msg errors" v-t="formErrors.main"></div>

  <slot name="form-bottom"></slot>

  <qit-google-recaptcha-v3 ref="googleReCaptchaV3" v-if="googleReCaptchaV3SiteKey" :site-key="googleReCaptchaV3SiteKey"></qit-google-recaptcha-v3>

  <div class="form-submitting-overlay"><div class="spin-loader"></div></div>
</form>
`,
}